import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const generatePdfReport = (data, filter, customDates) => {
  if (!data || !data.orders || data.orders.length === 0) {
    alert("No data available to download");
    return;
  }

  const doc = new jsPDF();
  
  // Add Title
  doc.setFontSize(18);
  doc.setTextColor(40);
  doc.text("Financial Summary Report", 14, 22);
  
  // Add Date Info
  doc.setFontSize(11);
  doc.setTextColor(100);
  let dateText = `Report Filter: ${filter.toUpperCase()}`;
  if (filter === "custom" && customDates.start && customDates.end) {
    dateText = `Report Range: ${customDates.start} to ${customDates.end}`;
  }
  
  doc.text(dateText, 14, 30);
  doc.text(`Total: Rs. ${data.total_amount}`, 14, 36); 
  doc.text(`Total Orders: ${data.total_orders}`, 14, 42);

  const tableColumn = [
    "Order ID", 
    "Item", 
    "Qty", 
    "Price", 
    "Total", 
    "Date", 
    "Time"
  ];
  const tableRows = [];

  // Format data
  data.orders.forEach((order) => {
    const localDate = new Date(
      new Date(order.created_at).getTime() + (5.5 * 60 * 60 * 1000)
    );
    const dateKey = localDate.toLocaleDateString("en-GB");
    const timeKey = localDate.toLocaleTimeString("en-IN");

    order.items.forEach((item, index) => {
      const totalVendorPrice = item.vendor_price * item.qty;
      const isFirst = index === 0;

      tableRows.push([
        isFirst ? order.order_id : "",
        item.name,
        item.qty,
        `Rs.${item.vendor_price}`,
        `Rs.${totalVendorPrice}`,
        isFirst ? dateKey : "",
        isFirst ? timeKey : ""
      ]);
    });
  });

  // Generate Table with the Sum at the bottom
  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    foot: [
      [
        "", 
        "", 
        "", 
        "GRAND TOTAL:", 
        `Rs.${data.total_amount}`, 
        "", 
        ""
      ]
    ],
    startY: 50,
    theme: 'grid',
    headStyles: { fillColor: [255, 75, 43] }, 
    footStyles: { fillColor: [240, 240, 240], textColor: [255, 75, 43], fontStyle: "bold" },
    styles: { fontSize: 9 },
    alternateRowStyles: { fillColor: [250, 250, 250] }
  });

  doc.save(`financial-report-${filter}.pdf`);
};